import { render, staticRenderFns } from "./ipfs.vue?vue&type=template&id=b68afaac"
import script from "./ipfs.vue?vue&type=script&lang=js"
export * from "./ipfs.vue?vue&type=script&lang=js"
import style0 from "./ipfs.vue?vue&type=style&index=0&id=b68afaac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports